import { render, staticRenderFns } from "./PrismicSlice.vue?vue&type=template&id=8a5b4388"
import script from "./PrismicSlice.vue?vue&type=script&lang=js"
export * from "./PrismicSlice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports